import { useNonBlockingLocation } from 'components/router/useNonBlockingLocation';
import { useFetchAccounts } from 'customHooks/useFetchAccounts';
import { first } from 'lodash';
import { MiniAccount } from 'types/domain';

const useCurrentAccountId = () => {
    const location = useNonBlockingLocation();
    const accountIdRegex = /accounts\/(?<accountId>[^/]+)/g;
    const foundAccountId = accountIdRegex.exec(location.pathname);
    const accountIdFromPathname = foundAccountId ? foundAccountId[1] : undefined;

    const { data: accounts } = useFetchAccounts();

    return typeof accountIdFromPathname !== 'undefined'
        ? Number(accountIdFromPathname)
        : (first(accounts) as MiniAccount)?.id;
};

export { useCurrentAccountId };
